export default __webpack_public_path__ + "static/media/Ballroll_00249.8c17304c.png";